<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4 col-lg-3">
        <div class="holder">
          <div id="filters" class="collapse show">
            <div class="search-box mb-4">
              <h6 class="m-0 mb-3">Palabra clave</h6>
              <el-input
                class="just-a-class"
                placeholder="Buscar"
                suffix-icon="el-icon-search"
                v-model="search"
              ></el-input>
              <button
                @click="handleSearchClick"
                type="button"
                class="btn btn-primary btn-sm btn-block mt-2"
              >Buscar</button>
            </div>
            <div class="search-tree mb-4">
              <h6 class="m-0 pb-2">Categorías</h6>
              <loading-animation v-show="isLoadingNavigation"></loading-animation>
              <vue-tree-navigation
                :items="navigationItems"
                :defaultOpenLevel="1"
                v-show="!isLoadingNavigation"
              />
            </div>
            <div class="search-year mb-4">
              <h6 class="m-0 mb-3">Año de publicación</h6>
              <loading-animation v-show="isLoadingYears"></loading-animation>
              <el-checkbox-group
                @change="handleFilterChange"
                v-model="yearsSelected"
                size="mini"
                :disabled="isLoadingPosts"
                v-show="!isLoadingYears"
              >
                <el-checkbox
                  class="m-0 mr-2 mb-2"
                  v-for="year in years"
                  :key="year.label"
                  :label="year.label"
                  border
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="search-month mb-4">
              <h6 class="m-0 mb-3">Mes de publicación</h6>
              <el-checkbox-group
                @change="handleFilterChange"
                v-model="monthsSelected"
                size="mini"
                :disabled="isLoadingPosts"
              >
                <el-checkbox
                  class="m-0 mr-2 mb-2"
                  v-for="month in months"
                  :key="month.label"
                  :label="month.label"
                  border
                ></el-checkbox>
              </el-checkbox-group>
            </div>
            <button
              @click="handleClearFilters"
              type="button"
              class="btn btn-primary btn-sm mt-2 btn-block"
            >Limpiar filtros</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <div class="holder-results mt-4 mt-lg-0" v-show="!isLoadingPosts && hasResults">
          <div class="header">
            <h6 class="m-0 p-0 mb-3 pb-3 border-bottom">
              <span v-if="!isLoadingPosts">{{total}} documentos encontrados</span>
            </h6>
          </div>
          <div class="files">
            <single-file
              v-for="post in posts"
              :post="post"
              :key="post.id"
              :isNorm="!dataSource ? false : true"
            ></single-file>
          </div>
          <paginate
            v-if="totalPages > 1"
            v-model="page"
            v-show="!isLoadingPosts"
            :page-count="totalPages"
            :prev-text="'Anterior'"
            :next-text="'Siguiente'"
            :container-class="'pagination d-flex justify-content-center'"
            :page-link-class="'page-link'"
            :page-class="'page-item'"
            :prev-link-class="'page-link'"
            :prev-class="'page-item'"
            :next-link-class="'page-link'"
            :next-class="'page-item'"
            :clickHandler="handlePaginationClick"
          ></paginate>
        </div>
        <div class="mx-auto center" v-show="!isLoadingPosts && !hasResults">
          <h5>No se encontraron coincidencias</h5>
          <p>Intentelo usando diferentes filtros</p>
        </div>
        <loading-animation class="mt-4 mt-lg-0" v-show="isLoadingPosts"></loading-animation>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SingleFile from './SingleFile.vue';
import LoadingAnimation from './LoadingAnimation.vue';

export default {
  name: 'Documents',
  components: {
    SingleFile,
    LoadingAnimation,
  },
  props: {
    viewType: String,
    catId: String,
    dataSource: String,
  },
  computed: {
    hasResults() {
      return this.posts.length;
    },
  },
  mounted() {
    this.apiPath = !this.dataSource
      ? 'wp-json/acuerdos/v1'
      : 'wp-json/norms/v1';
    this.getNavigationTree(this.$router.currentRoute.path);
    this.getDocumentList(this.$router.currentRoute.path);
    this.getAvailableYears();
  },
  data() {
    return {
      siteUrl: window.ui_data.site_url,
      apiPath: null,
      navigationItems: [{}],
      posts: [],
      page: 1,
      total: 0,
      totalPages: 0,
      isLoadingPosts: true,
      isLoadingNavigation: true,
      isLoadingYears: true,
      search: '',
      yearsSelected: [],
      years: [],
      monthsSelected: [],
      months: [
        { label: 'Enero' },
        { label: 'Febrero' },
        { label: 'Marzo' },
        { label: 'Abril' },
        { label: 'Mayo' },
        { label: 'Junio' },
        { label: 'Julio' },
        { label: 'Agosto' },
        { label: 'Septiembre' },
        { label: 'Octubre' },
        { label: 'Noviembre' },
        { label: 'Diciembre' },
      ],
    };
  },
  watch: {
    $route(to) {
      this.getDocumentList(to.path);
    },
  },
  methods: {
    getNavigationTree(path) {
      this.isLoadingNavigation = true;
      const query = this.getNavigationQuery(path);
      const apiUrl = `${this.siteUrl}/${this.apiPath}/${query}`;
      axios
        .get(apiUrl)
        .then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            this.navigationItems = response.data;
            if (!this.viewType) {
              this.navigationItems = [
                {
                  name: 'Mostrar todo',
                  path: '/all',
                  element: 'all',
                  children: response.data,
                },
              ];
            } else {
              this.navigationItems = response.data;
            }

            this.isLoadingNavigation = false;
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log('error :', err);
          this.isLoadingNavigation = false;
        });
    },
    getDocumentList(path) {
      this.isLoadingPosts = true;
      const categoryId = this.getCategoryId(path);
      const apiUrl = `${this.siteUrl}/${this.apiPath}/files`;
      axios
        .post(apiUrl, {
          category_id: categoryId,
          type: 'simple_time',
          years: this.yearsSelected,
          months: this.monthsSelected,
          search: this.search,
          page: this.page,
        })
        .then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            this.posts = response.data.posts;
            this.total = response.data.total;
            this.totalPages = response.data.max_num_pages;
            this.isLoadingPosts = false;
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log('err :', err);
          this.isLoadingPosts = false;
        });
    },
    getAvailableYears() {
      this.isLoadingYears = true;
      const apiUrl = `${this.siteUrl}/${this.apiPath}/years`;
      axios
        .get(apiUrl)
        .then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            this.years = response.data;
          }
          this.isLoadingYears = false;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log('err :', err);
          this.isLoadingYears = false;
        });
    },
    getNavigationQuery(path) {
      if (path === '/' && !this.viewType) {
        return 'tree/all';
      }

      if (this.viewType === 'segment') {
        return `tree/segment/${this.catId}`;
      }

      return 'tree/all';
    },
    getCategoryId(path) {
      // RegEx
      const IdReg = new RegExp('(id-\\d+$)');
      const matches = IdReg.exec(path);

      if (this.catId) {
        return this.catId;
      }

      if (!matches) {
        return 'all';
      }

      // Get the ID
      const categoryId = matches[0].split('id-').join('');
      if (!categoryId) {
        return 'all';
      }

      return categoryId;
    },
    handleFilterChange() {
      this.page = 1;
      this.getDocumentList(this.$router.currentRoute.path);
    },
    handleSearchClick() {
      this.page = 1;
      this.getDocumentList(this.$router.currentRoute.path);
    },
    handleClearFilters() {
      this.search = '';
      this.page = 1;
      this.yearsSelected = [];
      this.monthsSelected = [];
      this.getDocumentList(this.$router.currentRoute.path);
    },
    handlePaginationClick(pageNum) {
      this.page = pageNum;
      this.getDocumentList(this.$router.currentRoute.path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.TreeNavigation {
  li {
    padding: 0 !important;
  }
  a {
    &:hover {
      text-decoration: none !important;
    }
  }
}
.NavigationLevel__children {
  li {
    padding-left: 10px !important;
  }
}
.NavigationToggle__icon {
  padding: 2px !important;
  border: solid rgba(0, 0, 0, 0.5) !important;
  border-width: 0 1px 1px 0 !important;
}
.NavigationItem {
  a {
    text-decoration: none;
    font-size: 0.9rem;
  }
}
.router-link-exact-active {
  font-weight: bold;
}
.el-checkbox.is-bordered.el-checkbox--mini {
  padding: 3px 10px 3px 10px;
}
// DIVI FIX
.el-input--suffix .el-input__inner {
  padding-right: 30px !important;
}
.el-input__inner {
  -webkit-appearance: none !important;
  background-color: #fff !important;
  background-image: none !important;
  border-radius: 4px !important;
  border: 1px solid #dcdfe6 !important;
  box-sizing: border-box !important;
  color: #606266 !important;
  display: inline-block !important;
  font-size: inherit !important;
  height: 40px !important;
  line-height: 40px !important;
  outline: 0 !important;
  padding: 0 15px !important;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  width: 100% !important;
}
button.btn {
  -webkit-font-smoothing: auto !important;
}

.NavigationLevel {
  ul {
    margin: 0 !important;
    list-style: none !important;
    li {
      margin: 0 !important;
      list-style: none !important;
    }
  }
}
.NavigationToggle {
  position: relative !important;
  top: -3px !important;
  padding: 5px 5px 5px 3px !important;
  cursor: pointer !important;
}

.NavigationItem {
  display: inline-block !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  a {
    margin: 0 !important;
    padding-bottom: 0 !important;
  }
}

.NavigationLevel__parent {
  display: flex !important;
}

.NavigationLevel__children {
  padding-bottom: 0 !important;
}

.router-link-exact-active {
  font-weight: bold !important;
}

.el-input__icon {
  color: rgb(192, 196, 204) !important;
}

.el-checkbox.is-bordered {
  padding: 9px 20px 9px 10px !important;
  border-radius: 4px !important;
  border: 1px solid #dcdfe6 !important;
  box-sizing: border-box !important;
  line-height: normal !important;
  height: 40px !important;
}

.el-checkbox.is-bordered.el-checkbox--mini {
  padding: 3px 15px 3px 10px !important;
  border-radius: 3px !important;
  height: 28px !important;
}

.el-checkbox__input {
  cursor: pointer !important;
  line-height: 1 !important;
  margin-right: 5px !important;
}
.el-checkbox-button__inner,
.el-checkbox__input {
  white-space: nowrap !important;
  vertical-align: middle !important;
  outline: 0 !important;
}

.el-checkbox,
.el-checkbox__input {
  display: inline-block !important;
  position: relative !important;
}

.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner {
  height: 12px !important;
  width: 12px !important;
}
.el-checkbox__inner {
  display: inline-block !important;
  position: relative !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 2px !important;
  box-sizing: border-box !important;
  width: 14px !important;
  height: 14px !important;
  background-color: #fff !important;
  z-index: 1 !important;
  -webkit-transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46) !important;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46) !important;
}

.el-checkbox__original {
  opacity: 0 !important;
  outline: 0 !important;
  position: absolute !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
  z-index: -1 !important;
}

.el-checkbox.is-bordered.is-checked {
  border-color: #292f6e !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #292f6e !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #292f6e !important;
  border-color: #292f6e !important;
}

.pagination {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0 !important;
  margin: 0 !important;
  list-style: none !important;
  border-radius: 0.25rem !important;
  list-style: none !important;
}

.page-item.disabled .page-link {
  color: #6c757d !important;
  pointer-events: none !important;
  cursor: auto !important;
  background-color: #fff !important;
  border-color: #dee2e6 !important;
}

.page-item:first-child .page-link {
  margin-left: 0 !important;
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.page-item.active .page-link {
  z-index: 1 !important;
  color: #fff !important;
  background-color: #00124c !important;
  border-color: #00124c !important;
}

.page-link:not(:disabled):not(.disabled) {
  cursor: pointer !important;
}

.page-link {
  position: relative !important;
  display: block !important;
  padding: 0.5rem 0.75rem !important;
  margin-left: -1px !important;
  line-height: 1.25 !important;
  color: #00124c !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
}

.page-item {
  list-style: none !important;
}

#filters {
  h6 {
    font-weight: bold !important;
  }
  a {
    color: #292f6e !important;
  }
}

.holder-results {
  a {
    color: #292f6e !important;
  }
}

.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  position: relative !important;
  width: 100% !important;
  min-height: 1px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>
